import { createClient } from "@/shared/urql/urql";
import { executeMutation } from "@/shared/helper/executeMutation";
import { LogoutCurrentUserDocument } from "@/shared/generated/graphql";

export const logoutCurrentUser = async () => {
  const urqlClient = createClient();

  const error = await executeMutation(
    (data) => data?.logoutCurrentUser,
    () => urqlClient.mutation(LogoutCurrentUserDocument, {}).toPromise(),
  );
  if (error) throw error;
};
